/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Pt_KomunitasInputs */

const en_cp_pt_komunitas = /** @type {(inputs: Cp_Pt_KomunitasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community / competition (free 45 days)`)
};

const id_cp_pt_komunitas = /** @type {(inputs: Cp_Pt_KomunitasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunitas / kompetisi (gratis 45 hari)`)
};

/**
* | output |
* | --- |
* | "Community / competition (free 45 days)" |
*
* @param {Cp_Pt_KomunitasInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_pt_komunitas = /** @type {((inputs?: Cp_Pt_KomunitasInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Pt_KomunitasInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_pt_komunitas(inputs)
	return en_cp_pt_komunitas(inputs)
});